/**
 * 将页码数转为索引值对应的布尔值
 * @param total 总页数，6
 * @param pages 页码索引，[1, 2, 4, 5]
 * @returns [true, false, true, false, true, true]
 */
export function convertPageListToBooleanList(total: number, pages: number[]): boolean[] {
  const _allPages: boolean[] = new Array(total).fill(false);
  pages.forEach(p => {
    if (_allPages[p - 1] !== undefined) {
      _allPages[p - 1] = true;
    }
  });
  return _allPages;
}

export function range(start: number, end: number): number[] {
  return new Array(end)
    .fill('')
    .map((_, idx) => idx)
    .slice(start);
}

export function unique(arr: number[]): number[] {
  return Array.from(new Set(arr));
}

export const mPagePickerDashStyle = /^\d+-\d+$/; // 1-3
export const mPagePickerSpaceStyle = /^((\d+\s+)+(\d+\s*)|(\d+))$/; // 1 2 3
